import api from "../api";
import {handleApiError} from "../helpers/formatApiError";

export const submitUploadBulkJob = ({values, selectedAssetIds, uploadId, actions, onSuccess}) => {
    const bulkJob = {
        ...values,
        asset_ids: values.ids || selectedAssetIds,
    };

    // The upload ID lets the server enforce that every submitted asset belongs
    // to the upload, even if sessionStorage supplied stale cross-view IDs.
    return api.post('/api/bulk_jobs', {bulk_job: bulkJob, upload_id: uploadId})
        .then(res => {
            actions.resetForm();
            onSuccess(res.data);
            return res;
        })
        .catch(error => {
            handleApiError(error);
        })
        .finally(() => {
            actions.setSubmitting(false);
        });
};
